enum ContactsTypes {
    ADD_CONTACT = 'ADD_CONTACT',
    FILTER_CONTACTS = 'FILTER_CONTACTS',
}

export default ContactsTypes;